/*
.js-copyArea-targetのvalueをクリップボードにコピーする
<div class="js-copyArea">
    <input type="text" class="js-copyArea-target">
    <button type="button" class="js-copyArea-btn">
        URLをコピー
    </button>
</div>
*/
if (document.getElementsByClassName('js-copyArea')[0]) {
  module()
}
function module() {
  window.addEventListener('click', function (e) {
    const frame = e.target.closest('.js-copyArea')
    if (!frame) {
      return
    }
    if (!e.target.classList.contains('js-copyArea-btn')) {
      return
    }
    const btn = e.target

    const target = frame.querySelector('.js-copyArea-target')

    if (!target) {
      return
    }

    navigator.clipboard.writeText(target.value) // クリップボードにコピー

    btn.innerText = 'コピー完了'
    btn.style.color = '#fff'
    btn.style.background = 'green'

    setTimeout(() => {
      btn.innerText = 'URLコピー'
      btn.style.color = ''
      btn.style.background = ''
    }, 2000)
  })
}
